/**
 * Stat card component for displaying statistics
 */

interface StatCardProps {
  number: string;
  description: string;
  icon?: string;
}

export function StatCard({number, description}: StatCardProps) {
  return (
    <div className="text-center p-6 bg-white dark:bg-[#1E1E1E] rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
      <div className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-[#CCCCCC] mb-3">{number}</div>
      <div className="text-base md:text-lg text-gray-600 dark:text-[#858585] leading-relaxed">{description}</div>
    </div>
  );
}

